export default "__VITE_ASSET__DLNQOs8J__"